/**
 * Admin API runtime config.
 *
 * `VITE_API_BASE_URL` is consumed at build-time by Vite. In dev,
 * `localhost:3000` is the api package (CORS allows localhost:5173).
 * Production points at the deployed API host once envs land.
 *
 * Per LOCK 5 — no Vite dev proxy. Direct cross-origin to keep parity
 * with the mobile app's wire layer (single source of truth on the API).
 */
const FALLBACK_BASE_URL = 'http://localhost:3000';

export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL ?? FALLBACK_BASE_URL;

export const REQUEST_TIMEOUT_MS = 30_000;
